module.exports = __webpack_public_path__ + "img/landing-step3.388e1894.svg";